import {isLoggedIn} from "../../../../../../data/user.model";
import React, {useContext} from "react";
import {GetPackagingItem} from "../../../../../../interfaces/ecom/schema";
import {ProductContext} from "../../../../../pages/ProductStencil";
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";

export const Prices = ({data, onlySingle = false}: {data: GetPackagingItem, onlySingle?: boolean} ) => {
    if (!isLoggedIn()) {
        return null;
    }

    const {Packaging, activeProductIndex, config} = useContext(ProductContext);

    const translate = useI18N();
    const {VatIncluded} = config.Pricing;

    const {
        PriceUnit,
        WeightPrice,
        PromotionUnitPrice,
        PromotionUnitPriceDouble,
        PromotionWeightPrice,
        WeightUnit
    } = data;
    const isMulti = onlySingle ? false : Packaging.length > 1;

    const hasPromotion = !!PromotionUnitPriceDouble;
    const VatExclusion = () => {
        return <span className={"sku__vat"}>{`(${translate("excl. vat")})`}</span>;
    };

    return (
        <div className={`sku__pricing ${isMulti ? 'sku__pricing--multi' : ''}`}>
            <div className={`sku__price ${hasPromotion ? 'sku__price--regular' : ''}`}>
                <p className="sku__unit-price">
                    <span className="sku__unit-price--value">{PriceUnit}</span>
                    {!hasPromotion && <VatExclusion/>}
                </p>
                <p className="sku__weight-price">
                    {WeightPrice}/{WeightUnit} {!hasPromotion && <VatExclusion/>}
                </p>
            </div>
            {hasPromotion && (
                <div className="sku__price sku__price--promo">
                    <p className="sku__unit-price">
                        <span className="sku__unit-price--value">{PromotionUnitPrice}</span>
                        {!VatIncluded && <VatExclusion/>}
                    </p>
                    <p className="sku__weight-price">
                        {PromotionWeightPrice}/{WeightUnit} {!VatIncluded && <VatExclusion/>}
                    </p>
                </div>
            )}
        </div>
    )
}
